/**
 * Copyright (c) 2017 CRF Box Oy. All Rights Reserved. Company Confidential.
 */
import React from 'react';
import CModalWindow from '../common/modal/modalWindow.component.container';
import ParticipantStatusModalContainer from './participant.status.modal.container';

class ParticipantStatusModal extends React.Component {
  render() {
    return (
      <div id="participant-status-modal">
        <ParticipantStatusModalContainer />
      </div>
    );
  }
}

export default ParticipantStatusModal;
